import { type ReactNode, useState } from "react";

interface FormRowProps {
	label: string;
	helper?: string;
	required?: boolean;
	children: ReactNode;
}

export function FormRow({ label, helper, required, children }: FormRowProps) {
	return (
		<div style={{ marginBottom: 14 }}>
			<div
				style={{
					display: "flex",
					alignItems: "center",
					gap: 6,
					marginBottom: 5,
				}}
			>
				<label
					style={{ fontSize: 12, fontWeight: 600, color: "var(--a-ink-2)" }}
				>
					{label}
				</label>
				{required && (
					<span style={{ color: "var(--a-terracotta)", fontSize: 11 }}>*</span>
				)}
				{helper && (
					<span className="muted" style={{ fontSize: 11, marginLeft: "auto" }}>
						{helper}
					</span>
				)}
			</div>
			{children}
		</div>
	);
}

interface AToggleProps {
	defaultOn?: boolean;
	/** Mode contrôlé : si fourni, l'affichage suit cette valeur (se met à jour quand elle change). */
	on?: boolean;
	onChange?: (value: boolean) => void;
}

export function AToggle({ defaultOn = false, on, onChange }: AToggleProps) {
	const [internal, setInternal] = useState(defaultOn);
	const isControlled = on !== undefined;
	const value = isControlled ? on : internal;
	const toggle = () => {
		const next = !value;
		if (!isControlled) setInternal(next);
		onChange?.(next);
	};
	return (
		<button
			type="button"
			onClick={toggle}
			style={{
				width: 36,
				height: 20,
				borderRadius: 999,
				background: value ? "var(--a-terracotta)" : "var(--a-border-strong)",
				position: "relative",
				transition: "background 0.15s",
			}}
		>
			<span
				style={{
					position: "absolute",
					top: 2,
					left: value ? 18 : 2,
					width: 16,
					height: 16,
					borderRadius: "50%",
					background: "#fff",
					transition: "left 0.15s",
					boxShadow: "0 1px 2px rgba(0,0,0,0.2)",
				}}
			/>
		</button>
	);
}
